import React from "react";
import { isToday, format } from "date-fns";

import styled from "styles/styled_components";

import EditDayLink from "components/schedule/edit_day_link";
import { DateFormats } from "helpers/dates";

const StyledHeaderRow = styled.tr`
  font-family: ${(props) => props.theme.text.mediumFamily};
`;

interface IStyledHeaderCell {
  borderTop: boolean;
}

const StyledHeaderCell = styled.th<IStyledHeaderCell>`
  border: ${(props) => props.theme.lightBorder};
  border-width: 0 1px;
  ${({ theme, borderTop }) =>
    borderTop
      ? `border-top: ${theme.indicatorBorder} solid ${
          theme.colors.dsOrangeFiery
        };`
      : ""}
  color: ${(props) => props.theme.colors.dsGrayDark};
  font-family: ${(props) => props.theme.text.mediumFamily};
  font-size: ${(props) => props.theme.text.size.base};
  padding: ${(props) => props.theme.spacing.xsmall};
  padding-top: ${(props) => props.theme.spacing.medium};
  text-align: center;

  & svg {
    margin-left: ${(props) => props.theme.spacing.small};
    margin-bottom: 2px;
    vertical-align: text-bottom;
  }
`;

interface IScheduleTableHeaderProps {
  days: Date[];
  interactiveView: boolean;
}

function ScheduleTableHeader({
  days,
  interactiveView,
}: IScheduleTableHeaderProps) {
  const dayHeaderCells = days.map((day: Date) => {
    return (
      <StyledHeaderCell
        borderTop={interactiveView && isToday(day)}
        key={format(day, DateFormats.WEEKDAY_ORD)}
      >
        {format(day, DateFormats.WEEKDAY_ORD)}
        <EditDayLink day={day} />
      </StyledHeaderCell>
    );
  });

  return (
    <StyledHeaderRow id="shedule-table-header-row">
      {/* Empty th above person column */}
      <th />
      {dayHeaderCells}
    </StyledHeaderRow>
  );
}

export default ScheduleTableHeader;
